import React from 'react';
import styled from 'styled-components';

import EventName from './eventName';
import EventTime from './eventTime';
import Purchase from './purchase';

const EventCardWrapper = styled.div`
	padding: 0 20px 12px 20px;

	@media ${props => props.theme.device.lgDesktop} {
		width: 412px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border-top: none;
		padding: 12px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}

	@media ${props => props.theme.device.desktop} {
		width: 340px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border-top: none;
		padding: 8px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}
`;

const StyledEventName = styled(EventName)`
	display: none;

	@media ${props => props.theme.device.lgDesktop} {
		display: block;
	}

	@media ${props => props.theme.device.desktop} {
		display: block;
	}
`;

const EventCard = (): JSX.Element => (
	<EventCardWrapper>
		<div>
			<StyledEventName />
			<EventTime />
		</div>
		<Purchase />
	</EventCardWrapper>
);

export default EventCard;
